import { ElementRef, EventEmitter, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { AccountService } from '../../core/auth/account.service';
import { ReplaySubject, Subject } from "rxjs";
import { PasswordService } from '../../account/password/password.service';
import { COUNTRIES, LANGUAGES, TIMEZONES } from '../../app.constants';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import { UserService } from '../../core/user/user.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertModalComponent } from '../../shared/alert/alert-modal.component';
import { TrackerService } from '../../core/tracker/tracker.service';
import { LoginService } from '../../core/login/login.service';
import { CoachDetailsService } from '../slot/coach-details.service';
import { AutomatedMessageService } from '../automated-message/automated-message.service';
import { AutomatedMessage } from '../../shared/model/admin/automated-message.model';
import { takeUntil } from "rxjs/operators";
import { CoachReasoning } from '../../core/user/coach-reasoning.model';
import * as i0 from "@angular/core";
import * as i1 from "../../core/user/user.service";
import * as i2 from "../slot/coach-details.service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "../../core/auth/account.service";
import * as i5 from "../../account/password/password.service";
import * as i6 from "../../ng-jhipster/language";
import * as i7 from "@angular/forms";
import * as i8 from "../../core/tracker/tracker.service";
import * as i9 from "../../core/login/login.service";
import * as i10 from "../../ng-jhipster/service";
import * as i11 from "../automated-message/automated-message.service";
import * as i12 from "@angular/common";
import * as i13 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i14 from "../../shared/upload-image-component/profile-image.component";
import * as i15 from "../../shared/badge/badge.component";
import * as i16 from "@angular/material/form-field";
import * as i17 from "@angular/material/input";
import * as i18 from "@angular/material/select";
import * as i19 from "@angular/material/core";
import * as i20 from "ngx-mat-select-search";
import * as i21 from "./coach-welcome-automated-message.component";
import * as i22 from "@fortawesome/angular-fontawesome";
import * as i23 from "@ctrl/ngx-emoji-mart/ngx-emoji";
import * as i24 from "@angular/material/button";
import * as i25 from "@angular/material/icon";
import * as i26 from "../../shared/alert/alert-error.component";
import * as i27 from "@ngx-translate/core";
const _c0 = ["languageDeletionConfirmation"];
const _c1 = ["searchInput"];
function CoachSettingsComponent_div_1_div_6_mat_error_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "register.messages.error.usernameRequired"), " ");
} }
function CoachSettingsComponent_div_1_div_6_mat_error_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "register.messages.error.usernameMaxTwenty"), " ");
} }
function CoachSettingsComponent_div_1_div_6_mat_error_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "register.messages.error.numberLetterOnly"), " ");
} }
function CoachSettingsComponent_div_1_div_6_mat_error_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "register.messages.error.emailRequired"), " ");
} }
function CoachSettingsComponent_div_1_div_6_mat_error_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "register.messages.error.invalidEmail"), " ");
} }
function CoachSettingsComponent_div_1_div_6_mat_option_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const timezone_r14 = ctx.$implicit;
    i0.ɵɵproperty("value", timezone_r14);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(timezone_r14);
} }
function CoachSettingsComponent_div_1_div_6_mat_option_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r15 = ctx.$implicit;
    i0.ɵɵproperty("value", country_r15);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(country_r15);
} }
function CoachSettingsComponent_div_1_div_6_mat_option_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const fcl_r16 = ctx.$implicit;
    i0.ɵɵproperty("value", fcl_r16);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(fcl_r16 ? fcl_r16.name : null);
} }
function CoachSettingsComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "form", 10);
    i0.ɵɵlistener("ngSubmit", function CoachSettingsComponent_div_1_div_6_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.updateAccountInfo(); });
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵelement(5, "profile-image", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "badge-component", 14);
    i0.ɵɵelementStart(7, "div", 15);
    i0.ɵɵelementStart(8, "mat-form-field", 16);
    i0.ɵɵelementStart(9, "mat-label");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "input", 17);
    i0.ɵɵlistener("ngModelChange", function CoachSettingsComponent_div_1_div_6_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.coach.coachName = $event; });
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CoachSettingsComponent_div_1_div_6_mat_error_14_Template, 3, 3, "mat-error", 9);
    i0.ɵɵtemplate(15, CoachSettingsComponent_div_1_div_6_mat_error_15_Template, 3, 3, "mat-error", 9);
    i0.ɵɵtemplate(16, CoachSettingsComponent_div_1_div_6_mat_error_16_Template, 3, 3, "mat-error", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "mat-form-field", 16);
    i0.ɵɵelementStart(18, "mat-label");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "input", 18);
    i0.ɵɵlistener("ngModelChange", function CoachSettingsComponent_div_1_div_6_Template_input_ngModelChange_21_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.coach.coachEmail = $event; });
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, CoachSettingsComponent_div_1_div_6_mat_error_23_Template, 3, 3, "mat-error", 9);
    i0.ɵɵtemplate(24, CoachSettingsComponent_div_1_div_6_mat_error_24_Template, 3, 3, "mat-error", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "mat-form-field", 16);
    i0.ɵɵelement(26, "mat-label", 19);
    i0.ɵɵelementStart(27, "mat-select", 20);
    i0.ɵɵlistener("ngModelChange", function CoachSettingsComponent_div_1_div_6_Template_mat_select_ngModelChange_27_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.coach.coachTimezone = $event; });
    i0.ɵɵtemplate(28, CoachSettingsComponent_div_1_div_6_mat_option_28_Template, 2, 2, "mat-option", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "mat-form-field", 16);
    i0.ɵɵelement(30, "mat-label", 22);
    i0.ɵɵelementStart(31, "mat-select", 23);
    i0.ɵɵlistener("ngModelChange", function CoachSettingsComponent_div_1_div_6_Template_mat_select_ngModelChange_31_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.coach.coachCountry = $event; });
    i0.ɵɵtemplate(32, CoachSettingsComponent_div_1_div_6_mat_option_32_Template, 2, 2, "mat-option", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "mat-form-field", 16);
    i0.ɵɵelement(34, "mat-label", 24);
    i0.ɵɵelementStart(35, "mat-select", 25);
    i0.ɵɵelementStart(36, "mat-option");
    i0.ɵɵelement(37, "ngx-mat-select-search", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(38, CoachSettingsComponent_div_1_div_6_mat_option_38_Template, 2, 2, "mat-option", 21);
    i0.ɵɵpipe(39, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 27);
    i0.ɵɵelement(41, "button", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    let tmp_9_0;
    let tmp_10_0;
    let tmp_11_0;
    let tmp_15_0;
    let tmp_16_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r3.accountInfoForm);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("coachId", ctx_r3.coachId)("coachLogin", ctx_r3.coach.coachName)("doUpload", true)("size", 120);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coachDetails", ctx_r3.coachDetails);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 24, "settings.placeholder.accountName"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(13, 26, "settings.placeholder.accountName"));
    i0.ɵɵproperty("ngModel", ctx_r3.coach.coachName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_9_0 = ctx_r3.accountInfoForm.get("login")) == null ? null : tmp_9_0.errors == null ? null : tmp_9_0.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_10_0 = ctx_r3.accountInfoForm.get("login")) == null ? null : tmp_10_0.errors == null ? null : tmp_10_0.errors.maxlength);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_11_0 = ctx_r3.accountInfoForm.get("login")) == null ? null : tmp_11_0.errors == null ? null : tmp_11_0.errors.pattern);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 28, "settings.placeholder.emailAddress"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(22, 30, "settings.placeholder.emailAddress"));
    i0.ɵɵproperty("ngModel", ctx_r3.coach.coachEmail);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_15_0 = ctx_r3.accountInfoForm.get("email")) == null ? null : tmp_15_0.errors == null ? null : tmp_15_0.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_16_0 = ctx_r3.accountInfoForm.get("email")) == null ? null : tmp_16_0.errors == null ? null : tmp_16_0.errors.email);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r3.coach.coachTimezone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.timezones);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r3.coach.coachCountry);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.countries);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("formControl", ctx_r3.langCtrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r3.filterLangCtrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(39, 32, ctx_r3.filteredCoachingLanguages));
} }
function CoachSettingsComponent_div_1_div_7__svg_use_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 38);
} }
function CoachSettingsComponent_div_1_div_7__svg_use_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 39);
} }
function CoachSettingsComponent_div_1_div_7_span_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 48);
    i0.ɵɵlistener("click", function CoachSettingsComponent_div_1_div_7_span_8_ng_container_1_Template_span_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r31); const lang_r29 = restoredCtx.$implicit; const ctx_r30 = i0.ɵɵnextContext(4); return ctx_r30.changeEntityLanguage(lang_r29); });
    i0.ɵɵelementStart(2, "span", 49);
    i0.ɵɵelementStart(3, "span", 50);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "fa-icon", 51);
    i0.ɵɵlistener("click", function CoachSettingsComponent_div_1_div_7_span_8_ng_container_1_Template_fa_icon_click_5_listener() { const restoredCtx = i0.ɵɵrestoreView(_r31); const lang_r29 = restoredCtx.$implicit; const ctx_r32 = i0.ɵɵnextContext(4); return ctx_r32.confirmRemoveLanguage(lang_r29); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const lang_r29 = ctx.$implicit;
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r26.getTabColor(lang_r29));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r26.getLanguageName(lang_r29));
} }
function CoachSettingsComponent_div_1_div_7_span_8_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 52);
    i0.ɵɵlistener("click", function CoachSettingsComponent_div_1_div_7_span_8_li_10_Template_a_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r35); const language_r33 = restoredCtx.$implicit; const ctx_r34 = i0.ɵɵnextContext(4); return ctx_r34.addLanguage(language_r33); });
    i0.ɵɵelement(2, "ngx-emoji", 53);
    i0.ɵɵelementStart(3, "span", 54);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r33 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", language_r33.flagCode, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(language_r33.name);
} }
function CoachSettingsComponent_div_1_div_7_span_8_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, CoachSettingsComponent_div_1_div_7_span_8_ng_container_1_Template, 6, 2, "ng-container", 40);
    i0.ɵɵelementStart(2, "span", 41);
    i0.ɵɵelementStart(3, "a", 42);
    i0.ɵɵelement(4, "span", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul", 44);
    i0.ɵɵelementStart(6, "div", 45);
    i0.ɵɵelementStart(7, "input", 46, 47);
    i0.ɵɵlistener("keyup", function CoachSettingsComponent_div_1_div_7_span_8_Template_input_keyup_7_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(3); return ctx_r36.filterLanguages(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "hr");
    i0.ɵɵtemplate(10, CoachSettingsComponent_div_1_div_7_span_8_li_10_Template, 5, 2, "li", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r25.selectedLanguages);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngForOf", ctx_r25.coachingLanguagesFiltered);
} }
function CoachSettingsComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "div", 31);
    i0.ɵɵelementStart(3, "div", 32);
    i0.ɵɵelement(4, "h4", 33);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 34);
    i0.ɵɵlistener("click", function CoachSettingsComponent_div_1_div_7_Template__svg_svg_click_5_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.showCoachingLanguages = !ctx_r38.showCoachingLanguages; });
    i0.ɵɵtemplate(6, CoachSettingsComponent_div_1_div_7__svg_use_6_Template, 1, 0, "use", 35);
    i0.ɵɵtemplate(7, CoachSettingsComponent_div_1_div_7__svg_use_7_Template, 1, 0, "use", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, CoachSettingsComponent_div_1_div_7_span_8_Template, 11, 2, "span", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "coach-welcome-automated-message", 37);
    i0.ɵɵlistener("onAutomatedMessageSubmit", function CoachSettingsComponent_div_1_div_7_Template_coach_welcome_automated_message_onAutomatedMessageSubmit_9_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.onAutomatedMessageUpdated($event); })("onCoachReasoningSubmit", function CoachSettingsComponent_div_1_div_7_Template_coach_welcome_automated_message_onCoachReasoningSubmit_9_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r41 = i0.ɵɵnextContext(2); return ctx_r41.onCoachReasoningUpdated($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r4.elDistanceToTop > 158 ? "language-div-box-shadow" : "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.showCoachingLanguages);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.showCoachingLanguages);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.showCoachingLanguages);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("entityLanguage", ctx_r4.entityLanguage)("coachDto", ctx_r4.coach)("automatedMessage", ctx_r4.selectedAutomatedMessage)("coachReasoning", ctx_r4.getCoachReasoning(ctx_r4.entityLanguage));
} }
function CoachSettingsComponent_div_1_div_8_mat_error_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.currentPasswordRequired"), " ");
} }
function CoachSettingsComponent_div_1_div_8_mat_error_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.atLeast8"), " ");
} }
function CoachSettingsComponent_div_1_div_8_mat_error_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.maxlength"), " ");
} }
function CoachSettingsComponent_div_1_div_8_mat_error_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.newPasswordRequired"), " ");
} }
function CoachSettingsComponent_div_1_div_8_mat_error_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.atLeast8"), " ");
} }
function CoachSettingsComponent_div_1_div_8_mat_error_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.maxlength"), " ");
} }
function CoachSettingsComponent_div_1_div_8_mat_error_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.confirmPasswordRequired"), " ");
} }
function CoachSettingsComponent_div_1_div_8_mat_error_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.doNotMatch"), " ");
} }
function CoachSettingsComponent_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "form", 55);
    i0.ɵɵlistener("ngSubmit", function CoachSettingsComponent_div_1_div_8_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(2); return ctx_r50.updatePassword(); });
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "mat-form-field", 16);
    i0.ɵɵelementStart(6, "mat-label");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "input", 56);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementStart(11, "button", 57);
    i0.ɵɵlistener("click", function CoachSettingsComponent_div_1_div_8_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r51); const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.hideCurrent = !ctx_r52.hideCurrent; });
    i0.ɵɵelementStart(12, "mat-icon", 58);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CoachSettingsComponent_div_1_div_8_mat_error_14_Template, 3, 3, "mat-error", 9);
    i0.ɵɵtemplate(15, CoachSettingsComponent_div_1_div_8_mat_error_15_Template, 3, 3, "mat-error", 9);
    i0.ɵɵtemplate(16, CoachSettingsComponent_div_1_div_8_mat_error_16_Template, 3, 3, "mat-error", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "mat-form-field", 59);
    i0.ɵɵelementStart(18, "mat-label");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "input", 60);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementStart(23, "button", 57);
    i0.ɵɵlistener("click", function CoachSettingsComponent_div_1_div_8_Template_button_click_23_listener() { i0.ɵɵrestoreView(_r51); const ctx_r53 = i0.ɵɵnextContext(2); return ctx_r53.hideNew = !ctx_r53.hideNew; });
    i0.ɵɵelementStart(24, "mat-icon", 58);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, CoachSettingsComponent_div_1_div_8_mat_error_26_Template, 3, 3, "mat-error", 9);
    i0.ɵɵtemplate(27, CoachSettingsComponent_div_1_div_8_mat_error_27_Template, 3, 3, "mat-error", 9);
    i0.ɵɵtemplate(28, CoachSettingsComponent_div_1_div_8_mat_error_28_Template, 3, 3, "mat-error", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "mat-form-field", 59);
    i0.ɵɵelementStart(30, "mat-label");
    i0.ɵɵtext(31);
    i0.ɵɵpipe(32, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "input", 61);
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementStart(35, "button", 57);
    i0.ɵɵlistener("click", function CoachSettingsComponent_div_1_div_8_Template_button_click_35_listener() { i0.ɵɵrestoreView(_r51); const ctx_r54 = i0.ɵɵnextContext(2); return ctx_r54.hideConfirm = !ctx_r54.hideConfirm; });
    i0.ɵɵelementStart(36, "mat-icon", 58);
    i0.ɵɵtext(37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(38, CoachSettingsComponent_div_1_div_8_mat_error_38_Template, 3, 3, "mat-error", 9);
    i0.ɵɵtemplate(39, CoachSettingsComponent_div_1_div_8_mat_error_39_Template, 3, 3, "mat-error", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 27);
    i0.ɵɵelement(41, "button", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    let tmp_7_0;
    let tmp_8_0;
    let tmp_9_0;
    let tmp_16_0;
    let tmp_17_0;
    let tmp_18_0;
    let tmp_25_0;
    let tmp_26_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r5.passwordForm);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 27, "settings.placeholder.currentPassword"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 29, "settings.placeholder.currentPassword"));
    i0.ɵɵproperty("type", ctx_r5.hideCurrent ? "password" : "text");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", "Hide password")("aria-pressed", ctx_r5.hideCurrent);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r5.hideCurrent ? "visibility_off" : "visibility");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_7_0 = ctx_r5.passwordForm.get("currentPassword")) == null ? null : tmp_7_0.errors == null ? null : tmp_7_0.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_8_0 = ctx_r5.passwordForm.get("currentPassword")) == null ? null : tmp_8_0.errors == null ? null : tmp_8_0.errors.minlength);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_9_0 = ctx_r5.passwordForm.get("currentPassword")) == null ? null : tmp_9_0.errors == null ? null : tmp_9_0.errors.maxlength);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 31, "settings.placeholder.newPassword"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(22, 33, "settings.placeholder.newPassword"));
    i0.ɵɵproperty("type", ctx_r5.hideNew ? "password" : "text");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", "Hide password")("aria-pressed", ctx_r5.hideNew);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r5.hideNew ? "visibility_off" : "visibility");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_16_0 = ctx_r5.passwordForm.get("newPassword")) == null ? null : tmp_16_0.errors == null ? null : tmp_16_0.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_17_0 = ctx_r5.passwordForm.get("newPassword")) == null ? null : tmp_17_0.errors == null ? null : tmp_17_0.errors.minlength);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_18_0 = ctx_r5.passwordForm.get("newPassword")) == null ? null : tmp_18_0.errors == null ? null : tmp_18_0.errors.maxlength);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(32, 35, "settings.placeholder.confirmPassword"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(34, 37, "settings.placeholder.confirmPassword"));
    i0.ɵɵproperty("type", ctx_r5.hideConfirm ? "password" : "text");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", "Hide password")("aria-pressed", ctx_r5.hideConfirm);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r5.hideConfirm ? "visibility_off" : "visibility");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_25_0 = ctx_r5.passwordForm.get("confirmPassword")) == null ? null : tmp_25_0.errors == null ? null : tmp_25_0.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_26_0 = ctx_r5.passwordForm.get("confirmPassword")) == null ? null : tmp_26_0.errors == null ? null : tmp_26_0.errors.doNotMatch);
} }
function CoachSettingsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵelementStart(3, "span", 6);
    i0.ɵɵlistener("click", function CoachSettingsComponent_div_1_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(); return ctx_r55.switchToButton("accountInfo"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 7);
    i0.ɵɵlistener("click", function CoachSettingsComponent_div_1_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r56); const ctx_r57 = i0.ɵɵnextContext(); return ctx_r57.switchToButton("bio"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 8);
    i0.ɵɵlistener("click", function CoachSettingsComponent_div_1_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r56); const ctx_r58 = i0.ɵɵnextContext(); return ctx_r58.switchToButton("security"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CoachSettingsComponent_div_1_div_6_Template, 42, 34, "div", 9);
    i0.ɵɵtemplate(7, CoachSettingsComponent_div_1_div_7_Template, 10, 8, "div", 9);
    i0.ɵɵtemplate(8, CoachSettingsComponent_div_1_div_8_Template, 42, 39, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r0.getButtonColor("accountInfo"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.getButtonColor("bio"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.getButtonColor("security"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedButton === "accountInfo");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedButton === "bio");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedButton === "security");
} }
function CoachSettingsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 62);
    i0.ɵɵelementStart(1, "fa-icon", 63);
    i0.ɵɵlistener("click", function CoachSettingsComponent_ng_template_2_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r61); const ctx_r60 = i0.ɵɵnextContext(); return ctx_r60.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 64);
    i0.ɵɵelement(3, "jhi-alert-error");
    i0.ɵɵelementStart(4, "div", 65);
    i0.ɵɵelement(5, "h3", 66);
    i0.ɵɵelement(6, "p", 67);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 68);
    i0.ɵɵelementStart(8, "a", 69);
    i0.ɵɵlistener("click", function CoachSettingsComponent_ng_template_2_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r61); const ctx_r62 = i0.ɵɵnextContext(); return ctx_r62.close(); });
    i0.ɵɵelement(9, "span", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 71);
    i0.ɵɵlistener("click", function CoachSettingsComponent_ng_template_2_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r61); const ctx_r63 = i0.ɵɵnextContext(); return ctx_r63.removeLanguage(ctx_r63.languageToBeRemoved); });
    i0.ɵɵelement(11, "span", 72);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
export class CoachSettingsComponent {
    constructor(userService, coachDetailsService, modalService, accountService, passwordService, languageService, fb, trackerService, loginService, eventManager, automatedMessageService) {
        this.userService = userService;
        this.coachDetailsService = coachDetailsService;
        this.modalService = modalService;
        this.accountService = accountService;
        this.passwordService = passwordService;
        this.languageService = languageService;
        this.fb = fb;
        this.trackerService = trackerService;
        this.loginService = loginService;
        this.eventManager = eventManager;
        this.automatedMessageService = automatedMessageService;
        this.selectedButton = 'accountInfo';
        this.OK = 'OK';
        this.NOT_FOUND = 'Not Found';
        this.countries = COUNTRIES;
        this.timezones = TIMEZONES;
        this.regions = [];
        this.modalOptions = { windowClass: 'modal-window', size: 'md', centered: true };
        this.hideCurrent = true;
        this.hideNew = true;
        this.hideConfirm = true;
        this.charLength = 0;
        this.langKey = this.languageService.getCurrentLanguage();
        this.selectedAutomatedMessageLanguage = this.langKey;
        this.coachingLanguages = LANGUAGES;
        this.coachingLanguagesFiltered = LANGUAGES;
        this.filteredCoachingLanguages = new ReplaySubject(1);
        this.langCtrl = new FormControl();
        this.filterLangCtrl = new FormControl();
        this._onDestroy = new Subject();
        this.allLanguages = LANGUAGES;
        this.entityLanguage = this.languageService.getCurrentLanguage();
        this.selectedLanguages = [];
        this.onLanguageChange = new EventEmitter();
        this.showCoachingLanguages = true;
        this.accountInfoForm = this.fb.group({
            email: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50), Validators.email]],
            login: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(50)]],
            country: ['', [Validators.required]],
            timezone: ['', [Validators.required]],
            coachLanguages: ['', [Validators.required]],
        });
        this.passwordForm = this.fb.group({
            currentPassword: ['', [Validators.required]],
            newPassword: ['', [Validators.required, Validators.minLength(8)]],
            confirmPassword: ['', [Validators.required, Validators.minLength(8)]]
        });
    }
    ngOnInit() {
        this.userService.getCurrentCoach().subscribe(response1 => {
            this.coach = response1;
            this.coachId = this.coach.coachId;
            this.userService.getAllCoachReasoningsByCoachId([this.coachId]).subscribe(response2 => {
                this.coachReasoningList = response2.body;
                let selectedItems = [];
                this.coachingLanguages.forEach(item => {
                    for (let i = 0; i < this.coachReasoningList.length; i++) {
                        if (this.coachReasoningList[i].lang === item.code) {
                            item.coachReasoning = this.coachReasoningList[i].coachReasoningText;
                            selectedItems.push(item);
                            this.selectedLanguages.push(item.code);
                        }
                    }
                    this.langCtrl.setValue(selectedItems);
                });
                this.filterCoachingLanguages();
            });
            this.initialEmail = this.coach.coachEmail;
            this.coachDetailsService.findCoachDetails(this.coachId).subscribe(response3 => {
                this.coachDetails = response3.body;
            });
            this.loadAutomatedMessages();
            this.filterLangCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
                this.filterCoachingLanguages();
            });
        });
    }
    onScroll(event) {
        const el = document.querySelector(".language-div-sticky");
        if (el) {
            this.elDistanceToTop = window.pageYOffset + el.getBoundingClientRect().top;
        }
    }
    loadAutomatedMessages() {
        this.automatedMessageService.findAutomatedMessagesOfCoachByTrigger("ON_FIRST_SESSION_SCHEDULED").subscribe(response3 => {
            this.defaultAutomatedMessages = response3.body.filter(am => am.coach == null);
            this.automatedMessages = response3.body.filter(am => am.coach != null);
            if (!this.selectedAutomatedMessage) {
                this.changeEntityLanguage(this.selectedAutomatedMessageLanguage);
            }
        });
    }
    filterCoachingLanguages() {
        this.isFiltered = false;
        if (!this.coachingLanguages) {
            this.isFiltered = true;
            return;
        }
        let search = this.filterLangCtrl.value;
        if (!search) {
            this.filteredCoachingLanguages.next(this.coachingLanguages.slice());
            this.isFiltered = true;
            this.filteredCoachingLanguages.subscribe(v => {
                this.langCtrl.value.forEach((i1) => {
                    v.find(i2 => {
                        if (i1.code === i2.code) {
                            v.splice(v.indexOf(i2), 1);
                            v.unshift(i2);
                        }
                    });
                });
            });
            return;
        }
        else {
            search = search.toLowerCase();
        }
        this.filteredCoachingLanguages.next(this.coachingLanguages.filter(o => o ? o.name.toLowerCase().indexOf(search) > -1 : false));
        this.filteredCoachingLanguages.subscribe(v => {
            this.langCtrl.value.forEach((i1) => {
                v.find(i2 => {
                    if (i1.code === i2.code) {
                        v.splice(v.indexOf(i2), 1);
                        v.unshift(i2);
                    }
                });
            });
        });
        this.isFiltered = true;
    }
    getButtonColor(tab) {
        let result;
        if (this.selectedButton === tab)
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    getTabColor(tab) {
        let result;
        if (this.entityLanguage === tab)
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    switchToButton(tab) {
        this.selectedButton = tab;
    }
    changeEntityLanguage(lang) {
        var _a;
        this.entityLanguage = lang;
        this.selectedAutomatedMessage = this.getAutomatedMessage(lang);
        this.charLength = (_a = this.selectedAutomatedMessage) === null || _a === void 0 ? void 0 : _a.text.length;
        console.log(this.entityLanguage);
    }
    addLanguage(language) {
        console.log(language);
        if (this.selectedLanguages.find(l => l === language.code) === undefined) {
            this.selectedLanguages.push(language.code);
            let coachReasoning = new CoachReasoning();
            coachReasoning.coach = this.coach;
            coachReasoning.coachId = coachReasoning.coach.id;
            coachReasoning.lang = language.code;
            coachReasoning.deleted = false;
            this.coachReasoningList.push(coachReasoning);
        }
        this.searchInput.nativeElement.value = "";
        this.coachingLanguagesFiltered = this.coachingLanguages;
        this.saveCoachReasoningList();
    }
    close() {
        this.modalService.dismissAll();
    }
    confirmRemoveLanguage(language) {
        this.languageToBeRemoved = language;
        this.modalService.open(this.languageDeletionConfirmation, { size: 'md', backdrop: 'static', centered: true });
    }
    removeLanguage(language) {
        if (language != null) {
            let selectedLanguagesIndex = this.selectedLanguages.indexOf(language);
            this.selectedLanguages.splice(selectedLanguagesIndex, 1);
            this.coachReasoningList = this.coachReasoningList.filter(cr => cr.lang !== language);
            this.saveCoachReasoningList();
            this.close();
        }
    }
    getCoachReasoning(lang) {
        let coachReasoning = this.coachReasoningList.find(cr => cr.lang === lang);
        if (coachReasoning === null || coachReasoning === undefined) {
            coachReasoning = new CoachReasoning();
            coachReasoning.coachReasoningText = "";
            coachReasoning.experiences = "";
            coachReasoning.lang = lang;
            coachReasoning.educations = [];
            coachReasoning.iceBreakers = "";
        }
        else {
            if (coachReasoning.educations === null || coachReasoning.educations === undefined)
                coachReasoning.educations = [];
            if (coachReasoning.experiences === null || coachReasoning.experiences === undefined)
                coachReasoning.experiences = '';
            if (coachReasoning.iceBreakers === null || coachReasoning.iceBreakers === undefined)
                coachReasoning.iceBreakers = '';
            if (coachReasoning.coachReasoningText === null || coachReasoning.coachReasoningText === undefined)
                coachReasoning.coachReasoningText = '';
        }
        return coachReasoning;
    }
    filterLanguages() {
        let filter = this.searchInput.nativeElement.value.toString().toLowerCase();
        this.coachingLanguagesFiltered = this.coachingLanguages.filter(cl => cl.name.toLowerCase().includes(filter) || cl.nativeName.toLowerCase().includes(filter) || cl.code.toLowerCase().includes(filter));
        console.log(this.coachingLanguagesFiltered);
    }
    getAutomatedMessage(langKey) {
        let message = this.automatedMessages.find(am => am.lang === langKey);
        if (message == null || message.text.length <= 20) {
            message = this.defaultAutomatedMessages.find(am => am.lang === langKey);
        }
        if (message != null && message.text.length > 20) {
            return message;
        }
        else {
            return new AutomatedMessage(null, langKey, 'ON_FIRST_SESSION_SCHEDULED', '');
        }
    }
    updateAccountInfo() {
        this.coachReasoningList.forEach(cr => cr.coachReasoningText = null);
        for (let i = 0; i < this.langCtrl.value.length; i++) {
            let selectedItem = this.langCtrl.value[i];
            if (selectedItem.coachReasoning.length > 500) {
                this.openAlertModal('settings.messages.error.max500');
                return;
            }
            console.log(selectedItem);
            this.coachReasoningList.find(cr => cr.lang === selectedItem.code).coachReasoningText = selectedItem.coachReasoning;
        }
        console.log(this.coachReasoningList);
        let coachReasoningLanguages = this.coachReasoningList.map(cr => cr.lang);
        this.accountInfoForm.patchValue({
            email: this.coach.coachEmail,
            login: this.coach.coachName,
            country: this.coach.coachCountry,
            timezone: this.coach.coachTimezone,
            coachLanguages: coachReasoningLanguages,
        });
        console.log(this.accountInfoForm);
        if (this.accountInfoForm.valid) {
            this.saveCoachInfo();
            this.saveCoachReasoningList();
        }
        else {
            console.log(this.accountInfoForm);
        }
    }
    saveCoachInfo() {
        this.accountInfoSubscription = this.accountService.saveCoach(this.coach).subscribe(response => {
            console.log(response);
            if (response === this.OK) {
                this.openAlertModal("settings.messages.preferencesChanged");
                this.eventManager.broadcast('preferencesChangedModification');
                let country = this.coach.coachCountry;
                if (this.initialCountry !== country) {
                    this.trackerService.sendActivity("userSettings_countryChanged", { country });
                    this.initialCountry = country;
                }
                if (this.initialEmail !== this.coach.coachEmail) {
                    this.loginService.logout();
                }
            }
            else if (response === this.NOT_FOUND) {
                this.openAlertModal("password.messages.userNameNotFound");
            }
        }, (errorResponse) => {
            this.processErrorMessage(errorResponse);
        });
    }
    saveCoachReasoningList() {
        this.updateCoachReasoningSubscription = this.userService.updateCoachReasonings(this.coachReasoningList).subscribe(response2 => {
            console.log(this.coachReasoningList === response2);
        }, (errorResponse) => {
            this.processErrorMessage(errorResponse);
        });
    }
    processErrorMessage(errorResponse) {
        let errorKey = JSON.parse(errorResponse.error).errorKey;
        console.log(errorResponse.error);
        console.log(errorKey);
        if (errorKey === 'userexists') {
            this.openAlertModal("settings.messages.error.userexists");
            return;
        }
        else if (errorKey === 'emailexists') {
            this.openAlertModal("settings.messages.error.emailexists");
            return;
        }
    }
    updatePassword() {
        let currentPassword = this.passwordForm.get(['currentPassword']).value;
        let newPassword = this.passwordForm.get(['newPassword']).value;
        let confirmPassword = this.passwordForm.get(['confirmPassword']).value;
        if (newPassword !== confirmPassword) {
            this.passwordForm.get(['confirmPassword']).setErrors({ doNotMatch: true });
        }
        if (this.passwordForm.valid) {
            this.passwordSubscription = this.passwordService.save(newPassword, currentPassword).subscribe(response => {
                console.log(response);
                if (response === this.OK) {
                    this.openAlertModal("password.messages.passwordChanged");
                }
                else if (response === this.NOT_FOUND) {
                    this.openAlertModal("password.messages.userNameNotFound");
                }
            }, error => {
                console.log(error);
                this.openAlertModal("password.messages.passwordNotAuthenticated");
            });
        }
    }
    openAlertModal(message) {
        const modalRef = this.modalService.open(AlertModalComponent, this.modalOptions);
        modalRef.componentInstance.alertModalRef = modalRef;
        modalRef.componentInstance.language = this.languageService.getCurrentLanguage();
        modalRef.componentInstance.userAlertMessage = message;
    }
    ngOnDestroy() {
        if (this.passwordSubscription)
            this.passwordSubscription.unsubscribe();
        if (this.saveCoachSubscription)
            this.saveCoachSubscription.unsubscribe();
        if (this.updateCoachDetailsSubscription)
            this.updateCoachDetailsSubscription.unsubscribe();
        if (this.authenticateEmailSubscription)
            this.authenticateEmailSubscription.unsubscribe();
        if (this.authenticateUserNameSubscription)
            this.authenticateUserNameSubscription.unsubscribe();
        if (this.accountInfoSubscription)
            this.accountInfoSubscription.unsubscribe();
        if (this.updateCoachReasoningSubscription)
            this.updateCoachReasoningSubscription.unsubscribe();
        this._onDestroy.next();
        this._onDestroy.complete();
    }
    getLanguageName(langKey) {
        let language = this.allLanguages.find(l => l.code === langKey);
        return language ? language.nativeName : "";
    }
    onAutomatedMessageUpdated(automatedMessage) {
        this.loadAutomatedMessages();
    }
    onCoachReasoningUpdated(coachReasoning) {
        this.coachReasoningList = this.coachReasoningList.filter(cr => cr.lang !== coachReasoning.lang);
        this.coachReasoningList.push(coachReasoning);
        console.log(coachReasoning);
        this.saveCoachReasoningList();
    }
}
CoachSettingsComponent.ɵfac = function CoachSettingsComponent_Factory(t) { return new (t || CoachSettingsComponent)(i0.ɵɵdirectiveInject(i1.UserService), i0.ɵɵdirectiveInject(i2.CoachDetailsService), i0.ɵɵdirectiveInject(i3.NgbModal), i0.ɵɵdirectiveInject(i4.AccountService), i0.ɵɵdirectiveInject(i5.PasswordService), i0.ɵɵdirectiveInject(i6.JhiLanguageService), i0.ɵɵdirectiveInject(i7.FormBuilder), i0.ɵɵdirectiveInject(i8.TrackerService), i0.ɵɵdirectiveInject(i9.LoginService), i0.ɵɵdirectiveInject(i10.JhiEventManager), i0.ɵɵdirectiveInject(i11.AutomatedMessageService)); };
CoachSettingsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoachSettingsComponent, selectors: [["coach-settings"]], viewQuery: function CoachSettingsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.languageDeletionConfirmation = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
    } }, hostBindings: function CoachSettingsComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function CoachSettingsComponent_scroll_HostBindingHandler($event) { return ctx.onScroll($event); }, false, i0.ɵɵresolveWindow);
    } }, outputs: { onLanguageChange: "onLanguageChange" }, decls: 4, vars: 1, consts: [[1, "olha-theme"], ["class", "container", 4, "ngIf"], ["languageDeletionConfirmation", ""], [1, "container"], [1, "d-flex", "justify-content-center"], [1, "col-12", "col-sm-12", "col-md-10", "col-lg-8", "card", "p-0", "mb-4", "switch-div"], ["jhiTranslate", "settings.headers.accountInfo", 1, "btn", "span", 3, "ngClass", "click"], ["jhiTranslate", "settings.headers.bio", 1, "btn", "span", 3, "ngClass", "click"], ["jhiTranslate", "settings.headers.security", 1, "btn", "span", 3, "ngClass", "click"], [4, "ngIf"], ["name", "accountInfo", "role", "form", 3, "formGroup", "ngSubmit"], [1, "col-12", "col-sm-12", "col-md-10", "col-lg-8", "card", "form-card", "mb-4"], [1, "d-flex", "justify-content-center", "align-items-center", "profile-image-div"], [3, "coachId", "coachLogin", "doUpload", "size"], [3, "coachDetails"], [1, "d-flex", "flex-column"], ["appearance", "outline"], ["matInput", "", "formControlName", "login", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "formControlName", "email", 3, "placeholder", "ngModel", "ngModelChange"], ["jhiTranslate", "settings.placeholder.timezone"], ["tabindex", "-1", "formControlName", "timezone", 3, "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["jhiTranslate", "settings.placeholder.country"], ["tabindex", "-1", "formControlName", "country", 3, "ngModel", "ngModelChange"], ["jhiTranslate", "settings.placeholder.coachingLanguages"], ["tabindex", "-1", "multiple", "", 1, "form-control", 3, "formControl"], ["placeholderLabel", "Search", 3, "formControl"], [1, "text-center"], ["type", "submit", "jhiTranslate", "settings.form.saveChanges", 1, "btn", "btn-primary"], [3, "value"], [1, "d-flex", "justify-content-center", "language-div-sticky"], [1, "col-12", "col-sm-12", "col-md-10", "col-lg-8", "card", "automated-message-card", "mb-4", 3, "ngClass"], [1, "d-flex", "justify-content-between", "align-items-top"], ["jhiTranslate", "settings.headers.coachingLanguages", 1, "mb-1"], [1, "angle-icon", "d-sm-none", 3, "click"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-up-0A4A3A", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-down-0A4A3A", 4, "ngIf"], [3, "entityLanguage", "coachDto", "automatedMessage", "coachReasoning", "onAutomatedMessageSubmit", "onCoachReasoningSubmit"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-up-0A4A3A"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#angle-down-0A4A3A"], [4, "ngFor", "ngForOf"], ["ngbDropdown", "", "placement", "bottom", 1, "d-inline-block", "text-dark", "align-middle", "dropdown"], ["ngbDropdownToggle", "", "href", "javascript:void(0);", "id", "languagesnavBarDropdown", 1, "language-anchor"], ["jhiTranslate", "settings.headers.addLanguage", 1, "btn-tab", "span-tab-plus", "m-1", "text-center", 2, "display", "inline-grid", "text-decoration", "none"], ["ngbDropdownMenu", "", 1, "dropdown-menu-ul"], [1, "d-flex", "justify-content-center", "align-items-center"], ["type", "text", "placeholder", "Search..", 2, "border", "none", 3, "keyup"], ["searchInput", ""], [1, "span-tab", "m-1", "text-center", 2, "display", "inline-grid", 3, "ngClass", "click"], [1, "d-flex", "justify-content-between", "align-items-center"], [1, "m-1"], ["icon", "times-circle", 1, "m-1", "remove-language", 3, "click"], ["ngbDropdownItem", "", 1, "d-flex", "justify-content-start", "align-items-center", 3, "click"], [3, "emoji"], [1, "ml-1", "mb-1"], ["name", "security", "role", "form", 3, "formGroup", "ngSubmit"], ["matInput", "", "formControlName", "currentPassword", 3, "placeholder", "type"], ["mat-icon-button", "", "matSuffix", "", 1, "m-0", "p-0", 3, "click"], ["inline", "true"], ["appearance", "outline", 1, ""], ["matInput", "", "formControlName", "newPassword", 3, "placeholder", "type"], ["matInput", "", "formControlName", "confirmPassword", 3, "placeholder", "type"], [1, "olha-theme", "p-4", 2, "background-color", "white!important", "border-radius", "19px !important", "padding", "0!important"], ["icon", "times-circle", 1, "close", 3, "click"], [1, "main-body"], [1, "justify-content-start"], ["jhiTranslate", "settings.confirmDeleteLanguage"], ["jhiTranslate", "settings.confirmDeleteLanguageDescription"], [1, "d-flex", "justify-content-end"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", "m-2", 2, "text-decoration", "underline", 3, "click"], ["jhiTranslate", "entity.action.cancel"], ["type", "button", 1, "btn", "btn-primary", "m-2", 2, "width", "150px", 3, "click"], ["jhiTranslate", "entity.action.delete"]], template: function CoachSettingsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CoachSettingsComponent_div_1_Template, 9, 6, "div", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, CoachSettingsComponent_ng_template_2_Template, 12, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.coach);
    } }, directives: [i12.NgIf, i13.JhiTranslateDirective, i12.NgClass, i7.ɵNgNoValidate, i7.NgControlStatusGroup, i7.FormGroupDirective, i14.ProfileImageComponent, i15.BadgeComponent, i16.MatFormField, i16.MatLabel, i17.MatInput, i7.DefaultValueAccessor, i7.NgControlStatus, i7.FormControlName, i18.MatSelect, i12.NgForOf, i7.FormControlDirective, i19.MatOption, i20.MatSelectSearchComponent, i16.MatError, i21.CoachWelcomeAutomatedMessageComponent, i3.NgbDropdown, i3.NgbDropdownToggle, i3.NgbDropdownMenu, i22.FaIconComponent, i3.NgbDropdownItem, i23.EmojiComponent, i24.MatButton, i16.MatSuffix, i25.MatIcon, i26.AlertErrorComponent], pipes: [i27.TranslatePipe, i12.AsyncPipe], styles: [".olha-theme[_ngcontent-%COMP%]{background-color:#f7f4eb;height:100%}body[_ngcontent-%COMP%]{position:relative}fa-icon.eye[_ngcontent-%COMP%]{top:32px}.rounded[_ngcontent-%COMP%]{z-index:10;border-color:#000 !important;border-radius:19px !important}h2[_ngcontent-%COMP%]{color:#000;font-weight:normal;font-size:1.4rem}div.card-body[_ngcontent-%COMP%]{padding-bottom:0 !important}label[_ngcontent-%COMP%]{opacity:.5;font-weight:bold}.col[_ngcontent-%COMP%], .col-1[_ngcontent-%COMP%], .col-10[_ngcontent-%COMP%], .col-11[_ngcontent-%COMP%], .col-12[_ngcontent-%COMP%], .col-2[_ngcontent-%COMP%], .col-3[_ngcontent-%COMP%], .col-4[_ngcontent-%COMP%], .col-5[_ngcontent-%COMP%], .col-6[_ngcontent-%COMP%], .col-7[_ngcontent-%COMP%], .col-8[_ngcontent-%COMP%], .col-9[_ngcontent-%COMP%], .col-auto[_ngcontent-%COMP%], .col-lg[_ngcontent-%COMP%], .col-lg-1[_ngcontent-%COMP%], .col-lg-10[_ngcontent-%COMP%], .col-lg-11[_ngcontent-%COMP%], .col-lg-12[_ngcontent-%COMP%], .col-lg-2[_ngcontent-%COMP%], .col-lg-3[_ngcontent-%COMP%], .col-lg-4[_ngcontent-%COMP%], .col-lg-5[_ngcontent-%COMP%], .col-lg-6[_ngcontent-%COMP%], .col-lg-7[_ngcontent-%COMP%], .col-lg-8[_ngcontent-%COMP%], .col-lg-9[_ngcontent-%COMP%], .col-lg-auto[_ngcontent-%COMP%], .col-md[_ngcontent-%COMP%], .col-md-1[_ngcontent-%COMP%], .col-md-10[_ngcontent-%COMP%], .col-md-11[_ngcontent-%COMP%], .col-md-12[_ngcontent-%COMP%], .col-md-2[_ngcontent-%COMP%], .col-md-3[_ngcontent-%COMP%], .col-md-4[_ngcontent-%COMP%], .col-md-5[_ngcontent-%COMP%], .col-md-6[_ngcontent-%COMP%], .col-md-7[_ngcontent-%COMP%], .col-md-8[_ngcontent-%COMP%], .col-md-9[_ngcontent-%COMP%], .col-md-auto[_ngcontent-%COMP%], .col-sm[_ngcontent-%COMP%], .col-sm-1[_ngcontent-%COMP%], .col-sm-10[_ngcontent-%COMP%], .col-sm-11[_ngcontent-%COMP%], .col-sm-12[_ngcontent-%COMP%], .col-sm-2[_ngcontent-%COMP%], .col-sm-3[_ngcontent-%COMP%], .col-sm-4[_ngcontent-%COMP%], .col-sm-5[_ngcontent-%COMP%], .col-sm-6[_ngcontent-%COMP%], .col-sm-7[_ngcontent-%COMP%], .col-sm-8[_ngcontent-%COMP%], .col-sm-9[_ngcontent-%COMP%], .col-sm-auto[_ngcontent-%COMP%], .col-xl[_ngcontent-%COMP%], .col-xl-1[_ngcontent-%COMP%], .col-xl-10[_ngcontent-%COMP%], .col-xl-11[_ngcontent-%COMP%], .col-xl-12[_ngcontent-%COMP%], .col-xl-2[_ngcontent-%COMP%], .col-xl-3[_ngcontent-%COMP%], .col-xl-4[_ngcontent-%COMP%], .col-xl-5[_ngcontent-%COMP%], .col-xl-6[_ngcontent-%COMP%], .col-xl-7[_ngcontent-%COMP%], .col-xl-8[_ngcontent-%COMP%], .col-xl-9[_ngcontent-%COMP%], .col-xl-auto[_ngcontent-%COMP%]{padding-right:4px;padding-left:4px}.form-label[_ngcontent-%COMP%]{margin-right:.375rem !important}.switch-div[_ngcontent-%COMP%]{display:grid;grid-auto-columns:minmax(0, 1fr);grid-auto-flow:column}.btn-secondary[_ngcontent-%COMP%]{border:none}.span[_ngcontent-%COMP%]{border-radius:8px;cursor:pointer}.remove-language[_ngcontent-%COMP%]{font-size:16px}.span-tab[_ngcontent-%COMP%]{border:1px solid #44a38b;border-radius:5px;cursor:pointer;width:138px;height:30px;font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:600;line-height:130%}.span-tab-plus[_ngcontent-%COMP%]{border:1px solid #44a38b;border-radius:5px;cursor:pointer;width:138px;height:30px;font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:600;line-height:130%;color:var(--text-green-light-text, #8A9D98)}.education-tab[_ngcontent-%COMP%]{border-radius:10px;border:1px solid #000}.dropdown-toggle[_ngcontent-%COMP%]::after{display:none}.dropdown-menu-ul[_ngcontent-%COMP%]{border-radius:10px;background:var(--fill-background-white, #FFF);box-shadow:0 10px 20px 0 rgba(0,0,0,.13);border:none;margin-top:15px;max-height:400px;overflow:scroll}input[_ngcontent-%COMP%]:focus{outline:none}hr[_ngcontent-%COMP%]{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}.container[_ngcontent-%COMP%]{padding-top:90px}.btn[_ngcontent-%COMP%]{padding:8px !important}.btn-tab[_ngcontent-%COMP%]{padding:5px 0 !important;font-size:14px !important}.form-card[_ngcontent-%COMP%]{padding:30px 20px 30px 20px}.automated-message-card[_ngcontent-%COMP%]{padding:30px !important}.translation-switch-card[_ngcontent-%COMP%]{padding:5px !important}.angle-icon[_ngcontent-%COMP%]{height:24px;width:24px;cursor:pointer}[_nghost-%COMP%]  .mat-radio-button, [_nghost-%COMP%]  .mat-form-field, [_nghost-%COMP%]  .mat-select{font-family:\"Open Sans\",sans-serif !important;font-size:16px !important}[_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-inner-circle, [_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple), [_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple, [_nghost-%COMP%]  .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple{background-color:#44a38d}[_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle, [_nghost-%COMP%]  .mat-radio-outer-circle{border-color:#44a38d}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline{color:#cce9e0 !important}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline-thick{color:var(--main) !important}[_nghost-%COMP%]  .mat-form-field-wrapper{padding-bottom:16px !important}.profile-image-div[_ngcontent-%COMP%]{margin-bottom:15px}.video-icon[_ngcontent-%COMP%]{height:10px;width:14px}.badge[_ngcontent-%COMP%]{background:rgba(68,163,141,.1);color:#44a38b;border-radius:16px;padding:1px 20px;width:120px;height:30px;margin:5px}.text-area-parent[_ngcontent-%COMP%]{height:100% !important}.btn[_ngcontent-%COMP%]{min-width:1rem !important}.language-div-sticky[_ngcontent-%COMP%]{top:45px;position:sticky;z-index:99}.language-div-box-shadow[_ngcontent-%COMP%]{box-shadow:0 10px 20px 0 rgba(0,0,0,.13)}.close[_ngcontent-%COMP%]{cursor:pointer !important;float:right;margin-top:15px;margin-right:15px}.main-body[_ngcontent-%COMP%]{margin:30px}@media(min-width: 576px){.btn[_ngcontent-%COMP%]{padding:8px 16px 8px 16px !important}.form-card[_ngcontent-%COMP%]{padding:30px 120px 14px 120px}}"] });
